// extracted by mini-css-extract-plugin
export default {"linksWrapper":"style_linksWrapper__ZfMEj","linkItemWrapper":"style_linkItemWrapper__6GNGh"};